import { ObserversModule } from '@angular/cdk/observers';
import { NgModule } from '@angular/core';
import { MatCommonModule, MatRippleModule } from '@angular/material/core';
import { MatSlideToggleComponent } from './slide-toggle.component';
import { MatSlideToggleRequiredValidatorDirective } from './slide-toggle-required.validator';

@NgModule({
  imports: [MatRippleModule, MatCommonModule, ObserversModule],
  exports: [MatSlideToggleRequiredValidatorDirective, MatSlideToggleComponent, MatCommonModule],
  declarations: [MatSlideToggleComponent, MatSlideToggleRequiredValidatorDirective],
})
export class SlideToggleModule {}
